module.exports = __webpack_public_path__ + "img/parliament-2.cc524a6d.jpg";